'use client';

import { Analytics } from 'Shared/utils/client';
import { LINK } from '@constants';
import { Column } from '@viewup/ui';
import { SubHeaderLayout, WithLogin } from 'app/_components';
import { useGetEarnedPoints, useGetPendingPointSchedule } from 'app/viewing-money/_features/api';
import { useRouter } from 'next/navigation';
import { MonthlyCalendar } from '../MonthlyCalendar';
import { PointInformation, sumPendingPoint } from '../PointInformation';
import {
  POINT_NOTATION_NOTICE_LINK,
  PointNotationNoticeModal,
  usePointNotationNotice,
} from '../PointNotationNoticeModal';
import { ViewingBannerSlot } from './ViewingBannerSlot';

export const ViewingMoneyClientPage = WithLogin(() => {
  const router = useRouter();
  const pointNotationNotice = usePointNotationNotice();
  const { data: count } = useGetEarnedPoints();
  const { data: schedule } = useGetPendingPointSchedule();
  const pendingPoint = sumPendingPoint(schedule?.data);

  return (
    <SubHeaderLayout
      bgColor='bg.disabledLight'
      title={'뷰업 포인트'}
      {...((count?.data.exchangeablePoint || 0) >= 9999 && {
        bottomButton: {
          onClick: () => {
            Analytics.getInstance().track('VIEWING_MONEY_REFUND');
            router.push(LINK.MY_VIEWUP_REFUND);
          },
          text: '환급 하러가기',
        },
      })}
    >
      <Column gap={16} pb={32} pt={16} px={16}>
        <PointInformation data={count?.data} pendingPoint={pendingPoint} />

        <ViewingBannerSlot />

        <MonthlyCalendar />

        {/* 포인트 안맞는다고 일단 숨김처리 */}
        {/* <MonthlyPointEarned /> */}

        {/* 백엔드 API 타입 추가 필요 */}
        {/* <StackedPointEarned /> */}
      </Column>

      <PointNotationNoticeModal
        isOpen={pointNotationNotice.isOpen}
        onClickNotice={() => router.push(POINT_NOTATION_NOTICE_LINK)}
        onClose={pointNotationNotice.close}
        onNeverShowAgain={pointNotationNotice.neverShowAgain}
      />
    </SubHeaderLayout>
  );
});
